import { useDemoRequest } from "@/components/feature/DemoRequest";

export default function FinalCTA() {
  const { open } = useDemoRequest();

  return (
    <section className="relative py-20 md:py-28 bg-graphite-950 overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-emerald-accent/5 via-transparent to-transparent" />
      <div className="absolute inset-0 grid-pattern opacity-20" />

      <div className="relative z-10 section-padding">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white leading-tight mb-5">
            Need a Plan Built Around{" "}
            <span className="text-emerald-accent">Your Business?</span>
          </h2>
          <p className="text-base sm:text-lg text-silver-300 max-w-xl mx-auto leading-relaxed mb-10">
            Our team will work with you to recommend the right StackMap solution based on your goals, operational requirements, and growth ambitions.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={open}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-emerald-accent text-graphite-900 text-sm font-semibold hover:bg-emerald-hover transition-colors cursor-pointer whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-file-text-line text-base" />
              </span>
              Request Proposal
            </button>
            <button
              onClick={open}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-emerald-accent/40 text-emerald-accent text-sm font-semibold hover:bg-emerald-accent/10 transition-colors cursor-pointer whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-calendar-check-line text-base" />
              </span>
              Schedule a Consultation
            </button>
            <button
              onClick={open}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-graphite-600 text-silver-200 text-sm font-medium hover:text-white hover:border-silver-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-play-circle-line text-base" />
              </span>
              Book a Demo
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}